module.exports = __webpack_public_path__ + "static/media/Alcohol.f4f30d8e.svg";